import { render, staticRenderFns } from "./TabStockAdjustment.vue?vue&type=template&id=0d541d1f"
import script from "./TabStockAdjustment.vue?vue&type=script&lang=js"
export * from "./TabStockAdjustment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports